import { request } from './client';
import type { BankAccount, BankAccountInput, ConfirmedTransfer, PendingTransfer, TransferConfirmInput, TransferConfirmResult, TransferReverseResult } from '@kassa/shared';

export const transfersApi = {
  transfersPending: () => request<PendingTransfer[]>('GET', '/api/transfers/pending'),
  transfersConfirmed: () => request<ConfirmedTransfer[]>('GET', '/api/transfers/confirmed'),
  transferReverse: (paymentId: string, id: string) =>
    request<TransferReverseResult>('POST', `/api/transfers/payments/${encodeURIComponent(paymentId)}/reverse`, { id }),
  transferAccounts: () => request<BankAccount[]>('GET', '/api/transfers/accounts'),
  transferAccountCreate: (body: BankAccountInput) => request<BankAccount>('POST', '/api/transfers/accounts', body),
  transferConfirm: (docId: string, body: TransferConfirmInput) =>
    request<TransferConfirmResult>('POST', `/api/transfers/${encodeURIComponent(docId)}/confirm`, body),
};
